<template>
  <v-autocomplete :error-messages="errorMessages"
                  :items="countries"
                  :label="$t('components.country_select.select_label')"
                  :rules="rules"
                  @change="$emit('changed')"
                  @input="countrySelected($event)"
                  autocomplete="off"
                  item-color="white"
                  item-text="countryname"
                  item-value="countrycode"
                  outlined
                  return-object
                  :value="country"
                  :loading="loading"
                  :readonly="loading"
  >
    <template slot="append">
      <v-img :src="`/flags/4x3/${country.countrycode.toLowerCase()}.svg`"
             class="elevation-1"
             contain
             max-height="26"
             max-width="35"
             position="center center"
             v-if="country"
      >
        <template slot="placeholder">
          <v-row align="center" justify="center" no-gutters>
            <v-progress-circular color="black" indeterminate size="18" width="1"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </template>
    <template v-slot:item="data">
      <v-row align="center" justify="start" no-gutters>
        <v-img :src="`/flags/4x3/${data.item.countrycode.toLowerCase()}.svg`"
               class="pr-2"
               contain
               max-height="14"
               max-width="30"
               position="center center"
        >
          <template slot="placeholder">
            <v-row align="center" justify="center" no-gutters>
              <v-progress-circular indeterminate size="18" width="1"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        {{data.item.countryname}}
        (+{{data.item.mobilecountrycode}})
      </v-row>
    </template>
  </v-autocomplete>
</template>

<script>

    export default {
        name: 'CountrySelect',
        props: {
            rules: {
                type: Array,
                default: () => []
            },
            errorMessages: {
                type: Array,
                default: () => []
            },
            value: {
                required: false,
                type: Object
            }
        },
        data: () => ({
            country: null,
            countries: null,
            loading: false
        }),
        computed: {},
        methods: {
            getCountries() {
                this.loading = true;
                this.$http.get('/countries').then((resp) => {
                    this.countries = resp.data.data.countries;
                    if (resp.data.data.current && !this.value.countrycode) {
                        this.country = resp.data.data.current;
                    } else {
                        this.country = resp.data.data.countries.find(c => c.countrycode === this.value.countrycode);
                    }
                    this.$emit('input', this.country);
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            countrySelected(event) {
                this.country = event;
                this.$emit('input', this.country);
            }
        },
        mounted() {
            this.getCountries();
        }
    }
</script>

<style>
  .append-no-margin .v-input__append-inner {
    margin: 0 !important;
  }

  .append-no-margin .v-input__append-inner {
    height: 100%;
  }
</style>
